// This stores the location and type of a Port.
import { Obstacle } from './obstacle';
export class OverlapConvexHull {
    constructor(polyline, obstacles) {
        this.Polyline = polyline;
        this.Obstacles = Array.from(obstacles);
        this.PrimaryObstacle = this.Obstacles[0];
        Obstacle.RoundVerticesAndSimplify(this.Polyline);
    }
}
//# sourceMappingURL=OverlapConvexHull.js.map